import { createFileRoute, Link } from "@tanstack/react-router";
import { requireAdmin } from "@/lib/admin-guard";
import { ArrowLeft, Download } from "lucide-react";
import {
  GovernanceTeamRolesContent,
  ROLES,
} from "@/components/GovernanceTeamRolesContent";

export const Route = createFileRoute("/admin_/team-roles")({
  ssr: false,
  head: () => ({
    meta: [
      { title: "Governance & Team Roles — Admin" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  beforeLoad: requireAdmin,
  component: TeamRolesPage,
});

function exportCSV() {
  const headers = [
    "Job title",
    "Owner",
    "Credentials",
    "Status",
    "Summary",
    "Qualifications",
    "Responsibilities",
    "Boundaries",
    "Accountability",
    "Review date",
    "Last updated",
  ];
  const rows = ROLES.map((r) => [
    r.title,
    r.owner,
    r.credentials ?? "",
    r.status,
    r.summary,
    (r.qualifications ?? []).join(" | "),
    r.responsibilities.join(" | "),
    r.boundaries.join(" | "),
    r.accountability.join(" | "),
    r.reviewDate,
    r.lastUpdated,
  ]);
  const csv = [headers, ...rows]
    .map((row) => row.map((c) => `"${String(c).replace(/"/g, '""')}"`).join(","))
    .join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `recovery-trauma-governance-team-roles-${new Date()
    .toISOString()
    .slice(0, 10)}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}

function TeamRolesPage() {
  return (
    <div className="mx-auto max-w-6xl px-4 py-10 sm:px-6">
      <div className="mb-6 flex items-center justify-between gap-4">
        <Link
          to="/admin"
          className="inline-flex items-center gap-2 text-sm font-medium text-foreground/70 hover:text-foreground"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to Admin
        </Link>
        <div className="flex items-center gap-2">
          <Link
            to="/governance"
            className="inline-flex items-center gap-2 rounded-lg border border-gold/30 bg-card px-3 py-2 text-sm font-medium text-foreground hover:bg-gold/10"
          >
            View public page
          </Link>
          <button
            onClick={exportCSV}
            className="inline-flex items-center gap-2 rounded-lg border border-gold/30 bg-card px-3 py-2 text-sm font-medium text-foreground hover:bg-gold/10"
          >
            <Download className="h-4 w-4" />
            Export CSV
          </button>
        </div>
      </div>

      <GovernanceTeamRolesContent variant="admin" />
    </div>
  );
}
